import React from 'react';

import { Avatar } from '../../static';
import { s3LoadUrl } from '../../helper/s3LoadUrl';

import './styles.scss';

const UserAvatar = ({ avatar, ...props }) => {
	let url = '';

	if(avatar) {
		url = s3LoadUrl(avatar);
	};

	return (
		<div className="user__avatar">
			{avatar ? 
				<img src={url} alt="avatar"/> : <Avatar />}
		</div>
	)
};
  
export default UserAvatar;
